import AjaxServices from "../AjaxServices.js";
const SessionService = {
    logout: (successCallback, failureCallback) => {
        AjaxServices.post(AjaxServices.getWritableSessionServiceUrl("Account.LoginBO", "Logout", "BaseInVO"), {}, successCallback, failureCallback);
    },
};

export default SessionService;
